import { IOffer } from '@clickster/constant-definitions/dist-esm/entities/offer/types';
import { API_V2 } from '../lib/axios';
import { fetchAllPaginated } from './utils/fetch-all-paginated';
import { IOfferCategory } from '@clickster/constant-definitions/dist-esm/entities/offer-category/types';

interface ICountry {
  code: string;
  name: string;
  regions: {
    href: string;
  };
}

/**
 * Interface representing a region within a country
 * @interface IRegion
 */
interface IRegion {
  regionCode: string;
  regionName: string;
}

/**
 * Interface representing a city
 * @interface ICity
 */
interface ICity {
  cityCode: string;
  cityName: string;
}

const OFFERS_ENDPOINT = '/offers';

const list = async (params = {}) => {
  return fetchAllPaginated<IOffer>(API_V2, OFFERS_ENDPOINT, { populate: 'vertical', ...params });
};

const find = async (id: string) => {
  const response = await API_V2.get<IOffer>(`${OFFERS_ENDPOINT}/${id}`, {
    params: { populate: 'vertical' },
  });

  return response.data;
};

const create = async (data: IOffer) => {
  const response = await API_V2.post<IOffer>(`${OFFERS_ENDPOINT}`, data);

  return response.data;
};

const update = async (data: IOffer) => {
  const response = await API_V2.put<IOffer>(`${OFFERS_ENDPOINT}/${data._id}`, data);
  return response.data;
};

const findCategories = async () => {
  return fetchAllPaginated<IOfferCategory>(API_V2, 'offer-categories');
};

const findCountries = async () => {
  try {
    const response = await API_V2.get<ICountry[]>('countries');
    return response?.data;
  } catch (error) {
    console.error('Error fetching countries:', error);
    throw error;
  }
};

const getRegionsByCountry = async (countryCode: string) => {
  const response = await API_V2.get<IRegion[]>(`countries/${countryCode.toUpperCase()}/regions`);
  return response?.data;
};

/**
 * Get cities for a specific country and region
 * @param countryName - The country name
 * @param regionName - The region name
 * @returns Promise with array of city names
 */
const getCitiesByRegion = async (countryName: string, regionName: string) => {
  const response = await API_V2.post<string[]>(`cities`, {
    country: countryName,
    region: regionName,
  });
  return response?.data || [];
};

export const OfferService = {
  list,
  find,
  create,
  update,
  findCategories,
  findCountries,
  getRegionsByCountry,
  getCitiesByRegion,
};
